import script from "./gameReportGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./gameReportGallery.vue?vue&type=script&setup=true&lang=js"

import "./gameReportGallery.vue?vue&type=style&index=0&id=c3aa3a90&scoped=true&lang=scss"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3aa3a90"]])

export default __exports__